import { render } from "./Experience.vue?vue&type=template&id=2c56d128&ts=true"
import script from "./Experience.vue?vue&type=script&lang=ts"
export * from "./Experience.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__